import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const NUM_BUBBLES = 10;

const BubbleBackground = () => {
  const bubblesRef = useRef([]);

  useEffect(() => {
    const bubbles = bubblesRef.current;

    bubbles.forEach((bubble, i) => {
      // Animate each bubble floating around a wide range
      const xOffset = (Math.random() - 0.5) * 50;
      const yOffset = (Math.random() - 0.5) * 50;

      const tl = gsap.timeline({ repeat: -1, yoyo: true, delay: i * 0.2 });
      tl.to(bubble, {
        duration: 6 + Math.random() * 4,
        attr: {
          cx: `+=${xOffset}`,
          cy: `+=${yOffset}`,
        },
        ease: 'sine.inOut',
      });
    });

    const onScroll = () => {
      const scrollY = window.scrollY;
      bubbles.forEach((bubble, i) => {
        const baseSize = 3 + (i % 3);
        const dynamicSize = baseSize + Math.sin((scrollY + i * 100) / 200) * 1.5;

        gsap.to(bubble, {
          duration: 0.4,
          attr: {
            r: dynamicSize,
          },
          ease: 'power1.out',
        });
      });
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-screen h-screen -z-[9999] pointer-events-none">
      <svg
        className="w-full h-full"
        viewBox="0 0 100 100"
        // preserveAspectRatio="none"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        {Array.from({ length: NUM_BUBBLES }).map((_, i) => {
          const cx = Math.random() * 100;
          const cy = Math.random() * 100;
          const r = 2 + Math.random() * 3;

          return (
            <circle
              key={i}
              ref={(el) => (bubblesRef.current[i] = el)}
              cx={cx}
              cy={cy}
              r={r}
              fill="rgba(147, 197, 253, 0.2)"
              style={{ mixBlendMode: 'screen' }}
            />
          );
        })}
      </svg>
    </div>
  );
};

export default BubbleBackground;
